import { UtilsTypes } from 'constants/utilsTypes';
import OddsUtilsDescription from './OddsUtilsDescription';
import FormatDecimalOddsDescription from './FormatDecimalOddsDescription';
import GetAmericanOddsDescription from './GetAmericanOddsDescription';
import GetFractionalOddsDescription from './GetFractionalOddsDescription';
import FormatOddsDescription from './FormatOddsDescription';

export default function Description({ type }) {
    switch (type) {
        case UtilsTypes.ODDS_UTILS:
            return <OddsUtilsDescription />;
        case UtilsTypes.FORMAT_DECIMAL_ODDS:
            return <FormatDecimalOddsDescription />;
        case UtilsTypes.GET_AMERICAN_ODDS:
            return <GetAmericanOddsDescription />;
        case UtilsTypes.GET_FRACTIONAL_ODDS:
            return <GetFractionalOddsDescription />;
        case UtilsTypes.FORMAT_ODDS:
            return <FormatOddsDescription />;
        default:
            return undefined;
    }
}
